import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateReservationComponent } from './create/create.component';
import { RouterModule } from '@angular/router';
import { MdTabNavigationComponent } from '../md-tab-navigation/md-tab-navigation.component';
import { SharedModule } from 'shared/shared.module';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forRoot([
      {
        path: 'reservations',
        component: MdTabNavigationComponent,
        children: [
          { path: 'create', component: CreateReservationComponent },
        ]
      }
    ]),
  ],
  declarations: [CreateReservationComponent]
})
export class ReservationsModule { }



// WEBPACK FOOTER //
// ./src/app/modules/reservations/reservations.module.ts